import { EnumsInterface } from "@/interfaces/EnumsInterface";

const CurrentLocation:EnumsInterface[] = [
    {id: 0, value: 0, label: "In Jail/Police Custody"},
    {id: 1, value: 1, label: "Other known location"},
    {id: 2, value: 2, label: "Unknown"},
]

export default CurrentLocation